import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-1 block text-xs text-neutral50" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "text-textPrimary" }
const _hoisted_4 = {
  key: 1,
  class: "text-xs text-neutral50"
}
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "text-xs text-neutral50" }
const _hoisted_7 = { class: "whitespace-nowrap" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = { class: "mt-1 flex flex-wrap gap-1" }
const _hoisted_10 = { class: "mt-1 flex flex-wrap gap-1" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = ["data-testid"]
const _hoisted_13 = ["data-testid", "onClick"]

import { computed } from 'vue'

import QueueTable from '@/components/designSystem/QueueViews/QueueTable.vue'
import { QUEUE_TONE_PILL_CLASS } from '@/components/designSystem/QueueViews/types'
import type { QueueSort } from '@/components/designSystem/QueueViews/types'
import type {
  PriorityConfig,
  PriorityPaymentRow
} from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { priorityRowActions } from '../actions'
import type { PriorityActionDescriptor } from '../actions'
import {
  PRIORITY_SITUATION_TONES,
  PRIORITY_TYPE_LABELS,
  prioritySituationLabel
} from '../constants'
import { formatPriorityStationTime } from '../rowFormat'
import {
  formatSlaAlso,
  formatSlaKindLabel,
  formatSlaStageLine,
  priorityCriticalReasons,
  priorityThresholdsFor
} from '../slaFormat'
import { prioritySlaTableColumns } from '../tableColumns'
import PrioritySlaChip from './PrioritySlaChip.vue'
import PrioritySlaCountdown from './PrioritySlaCountdown.vue'

/**
 * Tabela do M3, usada na Tabela plana (com seleção e ordenação) e dentro de
 * cada grupo da Lista (sem elas). Um lugar só para as células com marcação.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsTable',
  props: {
    rows: {},
    serverNow: {},
    nowMs: {},
    config: {},
    selectable: { type: Boolean, default: false },
    selectedIds: { default: () => [] },
    isRowSelectable: { type: Function, default: undefined },
    sort: { default: null },
    testId: { default: 'priority-payments-table' }
  },
  emits: ["update:selectedIds", "update:sort", "action"],
  setup(__props: any, { emit }) {

const props = __props;





const columns = computed(() => prioritySlaTableColumns(props.serverNow))

const rowKey = (row: PriorityPaymentRow): number => row.doctorStationId

const thresholdsOf = (row: PriorityPaymentRow) =>
  row.sla ? priorityThresholdsFor(props.config, row.sla.kind) : null

const alsoOf = (row: PriorityPaymentRow) =>
  row.sla?.secondary ? formatSlaAlso(row.sla.secondary, row, props.nowMs, props.config) : null

const stationTimeOf = (row: PriorityPaymentRow) => formatPriorityStationTime(row)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QueueTable, {
    rows: _ctx.rows,
    columns: columns.value,
    "row-key": rowKey,
    sort: _ctx.sort,
    selectable: _ctx.selectable,
    "selected-ids": _ctx.selectedIds,
    "is-row-selectable": _ctx.isRowSelectable,
    "test-id": _ctx.testId,
    "onUpdate:selectedIds": _cache[0] || (_cache[0] = ($event: any) => (emit('update:selectedIds', $event))),
    "onUpdate:sort": _cache[1] || (_cache[1] = ($event: any) => (emit('update:sort', $event)))
  }, {
    "cell-time": _withCtx(({ row }) => [
      _createVNode(PrioritySlaCountdown, {
        sla: row.sla ?? null,
        row: row,
        "now-ms": _ctx.nowMs,
        thresholds: thresholdsOf(row),
        "test-id": `priority-payments-countdown-${row.doctorStationId}`
      }, null, 8, ["sla", "row", "now-ms", "thresholds", "test-id"])
    ]),
    "cell-state": _withCtx(({ row }) => [
      _createVNode(PrioritySlaChip, {
        sla: row.sla ?? null,
        "now-ms": _ctx.nowMs,
        thresholds: thresholdsOf(row),
        "test-id": `priority-payments-chip-${row.doctorStationId}`
      }, null, 8, ["sla", "now-ms", "thresholds", "test-id"])
    ]),
    "cell-sla-kind": _withCtx(({ row }) => [
      (row.sla)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (row.sla.state !== 'NOT_STARTED')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["inline-block rounded border px-1.5 py-px text-[11px] font-bold", 
            row.sla.kind === 'ANTECIPE'
              ? 'border-blue-300 text-blue-700'
              : 'border-primary text-primary'
          ])
                }, _toDisplayString(_unref(formatSlaKindLabel)(row.sla, row, _ctx.nowMs)), 3))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(formatSlaStageLine)(row.sla, row.situation)), 1),
            (alsoOf(row))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "m-0 mt-1 text-xs text-neutral50",
                  "data-testid": `priority-payments-also-${row.doctorStationId}`
                }, [
                  _createTextVNode(" Também: "),
                  _createElementVNode("b", _hoisted_3, _toDisplayString(alsoOf(row)?.kindLabel), 1),
                  _createTextVNode(" · " + _toDisplayString(alsoOf(row)?.detail), 1)
                ], 8, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
    ]),
    "cell-doctor": _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_5, _toDisplayString(row.doctorName), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(row.healthUnitName ?? row.scheduleName), 1)
    ]),
    "cell-station": _withCtx(({ row }) => [
      _createElementVNode("span", _hoisted_7, [
        _createTextVNode(_toDisplayString(stationTimeOf(row).text) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["ml-1 rounded px-1.5 py-0.5 font-mono text-[11px]", 
            stationTimeOf(row).isOutsideBrasilia
              ? 'bg-blue-50 text-blue-700'
              : 'bg-lightGray30 text-neutral50'
          ]),
          "data-testid": `priority-payments-timezone-${row.doctorStationId}`
        }, _toDisplayString(stationTimeOf(row).timezoneLabel), 11, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.types, (type, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `${type}-${index}`,
            class: _normalizeClass(["rounded border border-current px-1.5 py-px text-[11px] font-bold", 
            type.startsWith('IN_CASH')
              ? 'text-primary'
              : type === 'ANTECIPE_PAID'
                ? 'text-red-700'
                : 'text-blue-700'
          ])
          }, _toDisplayString(_unref(PRIORITY_TYPE_LABELS)[type]), 3))
        }), 128))
      ])
    ]),
    "cell-situation": _withCtx(({ row }) => [
      _createElementVNode("span", {
        class: _normalizeClass(["inline-block rounded-full px-2 py-0.5 text-xs font-medium", _unref(QUEUE_TONE_PILL_CLASS)[_unref(PRIORITY_SITUATION_TONES)[row.situation]]])
      }, _toDisplayString(_unref(prioritySituationLabel)(row)), 3),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(priorityCriticalReasons)(row), (reason) => {
          return (_openBlock(), _createElementBlock("span", {
            key: reason,
            class: "rounded-full border border-red-200 bg-white px-2 py-0.5 text-[11px] font-medium text-red-700",
            "data-testid": `priority-payments-critical-${row.doctorStationId}`
          }, _toDisplayString(reason), 9, _hoisted_11))
        }), 128))
      ]),
      (row.activityRecord?.rejectionJustification)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "mt-1 max-w-[38ch] border-l-2 border-red-600 pl-2 text-xs text-neutral50",
            "data-testid": `priority-payments-justification-${row.doctorStationId}`
          }, _toDisplayString(row.activityRecord.rejectionJustification), 9, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(({ row }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(priorityRowActions)(row), (action) => {
        return (_openBlock(), _createElementBlock("button", {
          key: action.key,
          type: "button",
          class: "rounded-[5px] border border-lightGray30 bg-transparent px-2 py-0.5 text-xs text-primary",
          "data-testid": action.testId,
          onClick: ($event: any) => (emit('action', { key: action.key, row }))
        }, _toDisplayString(action.label), 9, _hoisted_13))
      }), 128))
    ]),
    _: 1
  }, 8, ["rows", "columns", "sort", "selectable", "selected-ids", "is-row-selectable", "test-id"]))
}
}

})